import React from "react";

const Details = ({ rowData }) => {
  if (!rowData) return <p>No data available</p>;

  const fields = [
    { label: "ID", key: "id" },
    { label: "Branch ID", key: "branchId" },
    { label: "Kiosk ID", key: "kioskId" },
    { label: "Kiosk Name", key: "kioskName" },
    { label: "Kiosk Branch", key: "kioskBranch" },
    { label: "Kiosk Location", key: "kioskLocation", isLink: true },
    { label: "Issue Type", key: "issueType" },
    { label: "Description", key: "description" },
    { label: "Downtime Minutes", key: "downtimeMinutes" },
    { label: "Reported By", key: "reportedBy" },
    { label: "Reported On", key: "reportedOnDate" },
    { label: "Resolved By", key: "resolvedBy" },
    { label: "Resolved On", key: "resolvedOnDate" },
    { label: "Created Date", key: "createdDate" },
    { label: "Modified Date", key: "modifiedDate" },
  ];

  return (
    <div className="main-form">
      <div className="p-fluid formgrid grid">
        {fields.map(({ label, key, isLink }) => (
          <div className="field col-12 md:col-4 mb-3" key={key}>
            <label>{label}</label>
            <p>
              {isLink && rowData[key] ? (
                <a
                  href={rowData[key]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Location
                </a>
              ) : (
                rowData[key] || "N/A"
              )}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
